/**
 * Retrieve a computed field by key
 *
 * @param  {String} key
 * @param  {Object} dict
 * @param  {Object} context
 *
 * @return {mixed}
 */
function get (key, dict, context) {
  if (dict && typeof dict[key] === 'function') {
    return dict[key](context);
  }

  if (dict && typeof dict[key] !== 'undefined') {
    return dict[key];
  }

  if (context && typeof context[key] !== 'undefined') {
    return context[key];
  }

  return '';
}

/**
 * Parse computed fields from a string
 *
 * @param  {String} str
 * @param  {Object} dict
 * @param  {Object} context
 *
 * @return {mixed}
 */
function parse (str, dict, context) {
  if (str[0] === '<' && str[str.length - 1] === '>') {
    return get(str.substr(1, str.length - 2), dict, context);
  }

  if (typeof str === 'undefined') {
    return '';
  }

  return str;
}

/**
 * Replace computed fields in a string
 *
 * @param  {String}   str
 * @param  {Object}   dict
 * @param  {Function} callback
 * @param  {Object}   context
 *
 * @return {String}
 */
function replace (str, dict, callback, context) {
  return str.replace(/<.*?>/g, function (match) {
    const val = parse(match, dict, context);
    return (typeof callback === 'function') ? callback(val) : val;
  });
}

/**
 * Create a computed fields object
 *
 * @param  {Object} dict
 *
 * @return {Object}
 */
export default function computed (dict) {
  return {
    get (key, context) {
      return get(key, dict, context);
    },
    replace (str, callback, context) {
      return replace(str, dict, callback, context);
    },
    parse (str, context) {
      return parse(str, dict, context);
    }
  };
}
